import React from 'react';
import { motion } from "framer-motion";
import { useInView } from 'react-intersection-observer';

export default function Card({ title, description, step }) {
    const { ref, inView } = useInView({ triggerOnce: true, threshold: .8 })

    const variants = {
        visible: { y: '0px', opacity: 1, transition: { type: 'spring', duration: 4 } },
        hidden: { y: '20px', opacity: 0 }
    };

    return (
        <motion.div
            ref={ref}
            variants={variants}
            animate={inView ? 'visible' : 'hidden'}
            initial='hidden'
            className="p-[16px] border border-[#C8C8C8] rounded-[12px] flex items-center sm:block"
        >
            <div className='text-32 font-dmsans_b text-purple opacity-[0.3] mb-0 sm:mb-[24px] mr-[24px] ml-[8px] sm:ml-0'>{step}</div>
            <div>
                {title && <p className='text-16 font-dmsans_b leading-[24px] text-dark_blue mb-[8px]'>{title}</p>}
                <p className='text-16 font-dmsans_r leading-[24px] text-grey_light'>{description}</p>
            </div>
        </motion.div>
    );
};
